"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkClickEvent = exports.removeFromCartEvent = exports.addToCartCartEvent = exports.AddToCartEventNames = void 0;
var models_1 = require("./models");
var consts_1 = require("../consts");
var mappers_1 = require("../mappers");
var utils_1 = require("../utils");
var globalEventCreators_1 = require("../globalEventCreators");
var AddToCartEventNames;
(function (AddToCartEventNames) {
    AddToCartEventNames["AddToCart"] = "add-to-cart";
    AddToCartEventNames["AddToCartRedirect"] = "add-to-cart-redirect";
    AddToCartEventNames["MiniCartAdd"] = "mini-cart-add";
})(AddToCartEventNames = exports.AddToCartEventNames || (exports.AddToCartEventNames = {}));
var addToCartCartEvent = function (event, actionName) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var events = [];
    if (!((_c = (_b = (_a = event.eventData) === null || _a === void 0 ? void 0 : _a.cart) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.length) || !event.pmistore)
        return events;
    var isMiniCartAdd = actionName === AddToCartEventNames.MiniCartAdd;
    var action = isMiniCartAdd
        ? actionName
        : ((_e = (_d = event.eventData) === null || _d === void 0 ? void 0 : _d.origin) === null || _e === void 0 ? void 0 : _e.type) !== models_1.OriginTypes.DirectLink
            ? AddToCartEventNames.AddToCart
            : AddToCartEventNames.AddToCartRedirect;
    var eventName = action;
    var newEvent = {
        action: action,
        event: eventName,
        eventInfo: eventName,
        cart: __assign(__assign({}, (!isMiniCartAdd && 'currency' in event.eventData.cart && { currency: event.eventData.cart.currency || consts_1.NOT_AVAILABLE })), { product: (_f = event.eventData.cart) === null || _f === void 0 ? void 0 : _f.product.map(function (item) {
                var _a, _b;
                return (__assign(__assign({ cartLocation: ((_b = (_a = event.eventData) === null || _a === void 0 ? void 0 : _a.origin) === null || _b === void 0 ? void 0 : _b.location) || consts_1.NOT_AVAILABLE }, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE }));
            }), checkoutType: ((_g = event.eventData.cart) === null || _g === void 0 ? void 0 : _g.checkoutType) || consts_1.DEFAULT_CHECKOUT_TYPE }),
        pmistore: (0, mappers_1.mapStoreData)(event === null || event === void 0 ? void 0 : event.pmistore),
    };
    events.push(newEvent);
    if (((_j = (_h = event.eventData) === null || _h === void 0 ? void 0 : _h.origin) === null || _j === void 0 ? void 0 : _j.type) !== models_1.OriginTypes.DirectLink && ((_k = event.eventData.origin) === null || _k === void 0 ? void 0 : _k.link)) {
        var linkClickEvent = (0, exports.getLinkClickEvent)(event);
        events.push((0, utils_1.checkDataLayerValueEmpty)(linkClickEvent));
    }
    // ab:
    if (event.ab) {
        var ev = (0, globalEventCreators_1.createAbImpressionEvent)(event);
        events.push(ev);
    }
    return events;
};
exports.addToCartCartEvent = addToCartCartEvent;
var removeFromCartEvent = function (event, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var events = [];
    if (!((_c = (_b = (_a = event.eventData) === null || _a === void 0 ? void 0 : _a.cart) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.length))
        return events;
    events.push({
        action: action,
        event: event.eventName,
        eventInfo: event.eventName,
        cart: {
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); }),
            checkoutType: ((_d = event.eventData.cart) === null || _d === void 0 ? void 0 : _d.checkoutType) || consts_1.DEFAULT_CHECKOUT_TYPE,
        },
    });
    if (((_f = (_e = event.eventData) === null || _e === void 0 ? void 0 : _e.origin) === null || _f === void 0 ? void 0 : _f.type) === models_1.OriginTypes.UserAction && ((_h = (_g = event.eventData) === null || _g === void 0 ? void 0 : _g.origin) === null || _h === void 0 ? void 0 : _h.link)) {
        var linkClickEvent = (0, exports.getLinkClickEvent)(event);
        events.push((0, utils_1.checkDataLayerValueEmpty)(linkClickEvent));
    }
    return events;
};
exports.removeFromCartEvent = removeFromCartEvent;
var getLinkClickEvent = function (event) {
    var _a, _b, _c;
    var linkClickEvent = {
        event: 'linkclick',
        eventInfo: 'linkclick',
        link: {
            linkTitle: (_a = event.eventData.origin.link) === null || _a === void 0 ? void 0 : _a.linkTitle,
            linkModule: (_b = event.eventData.origin.link) === null || _b === void 0 ? void 0 : _b.linkModule,
            targetURL: (_c = event.eventData.origin.link) === null || _c === void 0 ? void 0 : _c.targetURL,
        },
    };
    return linkClickEvent;
};
exports.getLinkClickEvent = getLinkClickEvent;
